import { GeologicIntervalResponse } from 'types/api-responses';

export function getUniqueBasinNames(data: GeologicIntervalResponse): string[] {
  if (
    !data ||
    !data.geologicIntervals ||
    !Array.isArray(data.geologicIntervals)
  ) {
    return [];
  }

  const basinNamesSet = new Set<string>();

  data.geologicIntervals.forEach((interval) => {
    if (
      interval &&
      interval.basinName &&
      typeof interval.basinName === 'string' &&
      interval.basinName.trim() !== ''
    ) {
      basinNamesSet.add(interval.basinName);
    }
  });

  return Array.from(basinNamesSet);
}

export function getSelectedIntervalId(
  selectedInterval: string | null,
  intervalObjects: Array<{ geologicInterval: string; id: number }>
): number | null {
  if (!selectedInterval || !intervalObjects.length) return null;
  const selectedIntervalObj = intervalObjects.find(
    (interval) => interval.geologicInterval === selectedInterval
  );
  return selectedIntervalObj?.id || null;
}
